import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_COLLABORATION} from '../../metamodel/Concept';

export default class TechnologyCollaborationNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_COLLABORATION;
	}
}
